import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { PageCatchupWrapperComponentProps } from '../src/PageCatchupStreaming/PageCatchupStreamingEntryPoint.tsx';

export const PageCatchupComponent: LoadableType<PageCatchupWrapperComponentProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageCatchupComponent" */ '../src/PageCatchupStreaming/PageCatchupStreamingEntryPoint.tsx'
			)
		).PageCatchupComponentWithErrorBoundary,
});
